import moment from 'moment';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { OnlyFansSubscriberTransactionProduct } from '../types/transactions';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface SubscriberTransactionsUniqueSpendersGroupByMonth {
    _id: {
        year: number;
        month: number;
    };
    products: {
        product: OnlyFansSubscriberTransactionProduct;
        count: number;
    }[];
    uniqueCount: number;
}

const useSextforceMetricsAccountMonthlyUniqueSpenders = (startDate: Date, endDate: Date, timezone: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch Monthly Unique Spenders
    const fetchAccountMonthlyUniqueSpenders = async (
        startDate: Date,
        endDate: Date,
        timezone: string,
    ): Promise<SubscriberTransactionsUniqueSpendersGroupByMonth[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/monthlyuniquespenders?${new URLSearchParams({
            startDate: moment(startDate).tz(timezone, true).toISOString(),
            endDate: moment(endDate).tz(timezone, true).toISOString(),
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsMonthlyUniqueSpenders', params.userId, startDate, endDate, timezone],
        () => fetchAccountMonthlyUniqueSpenders(startDate, endDate, timezone),
        {
            refetchOnWindowFocus: false,
            staleTime: 60 * 1000 * 5,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useSextforceMetricsAccountMonthlyUniqueSpenders;
